import $ from "jquery";
import "slick-carousel";
import jss from 'jss'
import preset from 'jss-preset-default'
    class WidgetSlider extends elementorModules.frontend.handlers.Base {
        getDefaultSettings() {
            return {
            selectors: {
                slider: ".shaping-slider",
                slider_item: ".shaping-slider-item",
            },
            };
        }
        
        getDefaultElements() {
            const selectors = this.getSettings("selectors");
            return {
            $slider: this.$element.find(selectors.slider),
            $slider_item: this.$element.find(selectors.slider_item),
            };
        }
        initStyle(obj_height,height){
            jss.setup(preset())
            const styles = {
                height:{
                    height: `${height}px`
                }
            }
            const {classes} = jss.createStyleSheet(styles).attach()
            obj_height.classList.add(classes.height)
        }

        bindEvents() {
            let slider = this.elements.$slider[0];
            let slider_item = this.elements.$slider_item;
            let maxHeight = 0;
            let windowWidthInner = window.innerWidth;
            const THIS = this;
            $(slider)
                .on("init", function (event, slick, currentSlide, nextSlide) {
                    $('.shaping-slider .ecf-slider-arrow-slide-prev').addClass('disable');
                })
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    centerMode: true,
                    nextArrow: '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next"></button>',
                    prevArrow: '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev"></button>',
                    focusOnSelect: true,
                    centerPadding: "0",
                    infinite: false,
                    speed: 500,
                    responsive: [
                        {
                        breakpoint: 992,
                        settings: {
                            dots: true,
                            nextArrow: false,
                            prevArrow: false,
                            },
                        },
                        {
                            breakpoint:560,
                            settings:{
                                fade: false,
                                nextArrow: false,
                                prevArrow: false,
                                dots: true,
                                centerMode: true,
                                centerPadding: "13px",
                            }
                        }
                    ],
                })
                .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
                    $('.shaping-slider .ecf-slider-arrow-slide-prev').toggleClass('disable', nextSlide == 0);
                    $('.shaping-slider .ecf-slider-arrow-slide-next').toggleClass('disable', (nextSlide + 1) == slick.slideCount);
                })
                if($(slider_item) && windowWidthInner <=560){
                    $.each(slider_item,function(index, value){
                      let heightItem = $(slider_item[index]).height();
                      maxHeight < heightItem ? maxHeight = heightItem : '';
                    });
                    $.each(slider_item,function(index, value){
                    THIS.initStyle(slider_item[index],maxHeight)
                    });
                  }
        }
        
    }
    
    jQuery(window).on("elementor/frontend/init", () => {
    const addHandler = ($element) => {
        elementorFrontend.elementsHandler.addHandler(WidgetSlider, {
        $element,
        });
    };
    
    elementorFrontend.hooks.addAction(
        "frontend/element_ready/ecf_list_and_slide.default",
        addHandler
    );
    });